<template>
    <div :id="id" :style="{height:height}" />
</template>

<script>
import resize from './resize.js'
export default {
    name:"yl-lc-echarts-pie",
    mixins: [resize],
    props: {
        chartData: {
            type: Object,
            default: () => {
                return {}
            }
        },
        id: {
            type: String,
            default: 'PieChart'
        },
        height: {
            type: String,
            default: '400px'
        }
    },
    data() {
        return {
            chart: null,
            chart: null
        }
    },
    mounted() {
        this.initChart()
    },
    beforeDestroy() {
        if (!this.chart) {
            return
        }
        this.chart.dispose()
        this.chart = null
    },
    methods: {
        initChart() {
            let _this = this
            // let myChart = this.echarts.init(this.$refs.lineChert)
            this.chart = this.echarts.init(document.getElementById(this.id))
            // 自定义颜色列表赋值
            let colorList = this.chartData.colorList
            this.initData = Object.assign(this.chartData,{
                title: {
                    text: this.chartData.titleText ? this.chartData.titleText : "",
                },
            });

            // this.initData = {
            //     // 标题
            //     title: {
            //         text: this.chartData.titleText ? this.chartData.titleText : "",
            //         ...this.chartData.title
            //     },
            //     graphic: this.chartData.graphic,
            //     // legend: {
            //     //     orient: 'vertical',
            //     //     left: 'left',
            //     // },
            //     tooltip: {
            //         trigger: 'item',
            //         // formatter: '{b}  {d}%',
            //         formatter: function (params) {
            //             let str = params.seriesName + "<br />" + '<span style="display:inline-block;margin-right:5px;border-radius:50%;width:10px;height:10px;left:5px;background-color:'+params.color+'"></span>' 
            //             + params.name + '<span style="display:inline-block;margin-left:20px;"></span>' + params.percent + "%";
            //             let noSeriesName = '<span style="display:inline-block;margin-right:5px;border-radius:50%;width:10px;height:10px;left:5px;background-color:'+params.color+'"></span>' 
            //             + params.name + '<span style="display:inline-block;margin-left:20px;"></span>' + params.percent + "%";
            //             if(_this.chartData.seriesName){
            //                 return str;
            //             }else{
            //                 return noSeriesName;
            //             }
            //         },
            //         borderColor: "#ffffff",
            //     },
            //     series: [
            //         {
            //             name: this.chartData.seriesName,
            //             type: 'pie',
            //             // radius: '65%',
            //             // 圆环的时候设置
            //             radius: this.chartData.seriesRadius || ['0%', '70%'],
            //             label: this.chartData.serieslabelData,
            //             // label: {
            //             //     show: this.chartData.seriesLable || false,
            //             //     // 外侧：outside 内侧inner 中心位置center
            //             //     position: this.chartData.seriesPosition || "outside",
            //             //     formatter: '中心文字',
            //             //     // formatter: '{b} : {c}',
            //             // },
            //             // 高亮状态的扇区和标签样式。
            //             // emphasis: {
            //             //     label: {
            //             //         show: true,
            //             //         formatter: "中心文字",
            //             //         // fontSize: '40',
            //             //         // fontWeight: 'bold'
            //             //     }
            //             // },
            //             center: this.chartData.seriesCenter || ["50%", "50%"],
            //             // 选中是否弹出
            //             // selectedMode: 'single',
            //             data: this.chartData.seriesData || [],
            //             // 颜色自定义配置
            //             itemStyle: colorList && colorList.length > 0 ? {
            //                 normal: {
            //                     color: (params)=>{
            //                         return colorList[params.dataIndex]
            //                     }
            //                 }
            //             } : {},
                        
            //         }
            //     ]
            // }
            // // 是否展示图例组件
            // if(this.chartData.legend){
            //     let obj = {
            //         ...this.chartData.legend,
            //         // // itemWidth: 5,
            //         // // itemHeight: 5,
            //         // // itemGap: 15,
            //         // top: 40,
            //         // left: 10,
            //         data: this.chartData.seriesData.map((itm)=>{return itm.name}),
            //         // 图例内容自定义
            //         // formatter: function (name) {
            //         //     let data = _this.initData.series[0].data;
            //         //     let tarValue;
            //         //     let str = "";
            //         //     const count = _this.arrCount(data)
            //         //     data.forEach(itm =>{
            //         //         if(itm.name == name){
            //         //             tarValue = itm.value
            //         //         }
            //         //     })
            //         //     let b = _this.$function.AMOUNT.fixedNumber(tarValue * 100 / count, 2) + '%'
            //         //     str = name + " " + tarValue + " " + b
            //         //     return str
            //         // },
            //     }
            //     // formatter属性定义
            //     obj.formatter = obj.formatter ? obj.formatter : function(name) {
            //         let data = _this.initData.series[0].data;
            //         // 数量
            //         let tarValue;
            //         let str = "";
            //         const count = _this.arrCount(data)
            //         data.forEach(itm =>{
            //             if(itm.name == name){
            //                 tarValue = itm.value
            //             }
            //         })
            //         // 百分比
            //         let percentage = _this.$function.AMOUNT.fixedNumber(tarValue * 100 / count, 2) + '%'
            //         let obj = {
            //             "name": name,
            //             "num": tarValue,
            //             "percentage": percentage
            //         };
            //         if(_this.chartData.legend.formatterAtter){
            //             _this.chartData.legend.formatterAtter.forEach(item=>{
            //                 str += obj[item] + '  '
            //             })
            //         }else{
            //             str = name + '  ' + tarValue
            //         }
            //         // str = name + " " + tarValue + " " + percentage;
            //         return str
            //     }
            //     this.initData.legend = obj;
            // }
            // 清除画布
            this.chart.clear()
            this.chart.setOption(this.initData)
        },
        legendFormatter(name) {
            let _this = this
            let data = _this.initData.series[0].data;
            let tarValue;
            let str = "";
            const count = _this.arrCount(data)
            data.forEach(itm =>{
                if(itm.name == name){
                    tarValue = itm.value
                }
            })
            let b = _this.$function.AMOUNT.fixedNumber(tarValue * 100 / count, 2) + '%'
            str = name + " " + tarValue + " " + b
            return str
        },
        arrCount(arr) {
            let count = 0
            arr.forEach(item => {
                count = count + item.value
            })
            return count
        },
        // 更新处理最新echarts数据
        setEchartOption(){
            this.initChart()
        }
    }
}
</script>